import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { RegionSingleResponse } from '@lib/api/models/region';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthenticationService } from '@lib/auth/authentication.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { Provider } from '@lib/api/models/provider';
import { PromptRegionProviderRemoveDialogComponent } from '../../../../dialogs/prompt/provider/prompt-region-provider-remove-dialog.component';
import { catchError, of, tap } from 'rxjs';

@Component({
    selector: 'app-region-providers-tab',
    imports: [ComponentsModule, AsyncPipe, RouterLink],
    templateUrl: './region-providers-tab.component.html',
    standalone: true,
    styleUrl: './region-providers-tab.component.scss'
})
export class RegionProvidersTabComponent {
    @Input() regionData: RefreshableResult<RegionSingleResponse> | undefined;
    @Input() regionId: string | undefined;
    @Output() providerRemovedEvent: EventEmitter<void> = new EventEmitter<void>();

    private readonly _authService = inject(AuthenticationService);
    private readonly _dialog = inject(DialogService);
    private readonly _snackBar = inject(SnackBarService);

    protected user = toSignal(this._authService.user$);

    removeFromRegion(provider: Provider) {
        if (!this.regionId) {
            return;
        }

        PromptRegionProviderRemoveDialogComponent.show(this._dialog, {
            provider,
            regionId: this.regionId
        }).closed.pipe(
            tap(() => {
                this.regionData?.refresh();
                this.providerRemovedEvent.emit();
            }),
            catchError(() => {
                this._snackBar.open({
                    colour: 'error',
                    dismissable: false,
                    icon: 'error_outline',
                    title: 'Failed to remove provider from region',
                    actions: [{ id: 'ok', label: 'OK' }]
                });
                return of(null);
            })
        ).subscribe();
    }
}
